export const CARD_POST_EVENTS = {
  HASHTAG_CLICK: 'mfe-card-posts-hashtag-click',
  FOOTER_META_CLICK: 'mfe-card-posts-footer-meta-click',
  TAG_ROW_CLICK: 'mfe-card-posts-tag-row-click',
  TAG_MODAL_CLICK: 'mfe-card-posts-tag-modal-click',
  READ_FULL_POST_CLICK: 'mfe-card-posts-read-full-post-click',
  FULL_POST_MODAL_CLICK: 'mfe-card-posts-full-post-modal-click',
  TAG_ADDED: 'mfe-card-posts-tag-added',
  TAG_REMOVED: 'mfe-card-posts-tag-removed',
  CLASSIFY: 'mfe-card-posts-classify',
  SENTIMENT: 'mfe-card-posts-sentiment',
  CHECK: 'mfe-card-posts-check',
  VIEW: 'mfe-card-posts-view',
  ACTIONS: 'mfe-card-posts-actions',
  DELETE: 'mfe-card-posts-delete',
  BAN_USER: 'mfe-card-posts-ban-user',
  ADVANCED_TOGGLE: 'mfe-card-posts-advanced-toggle',
  INIT_POST_STATE: 'mfe-card-posts-init-post-state',
  CARD_READY: 'mfe-card-posts-card-ready',
  REMOVE_POST: 'mfe-card-posts-remove-post',
  REFRESH_DATA: 'mfe-card-posts-refresh-data',
  DARK_POST_DETECTED: 'mfe-card-posts-dark-post-detected',
  DYNAMIC_AD_DETECTED: 'mfe-card-posts-dynamic-ad-detected',
  CROSS_POST_DETECTED: 'mfe-card-posts-cross-post-detected',
  HOT_POST_DETECTED: 'mfe-card-posts-hot-post-detected',
  SET_AVAILABLE_TAGS: 'mfe-card-posts-set-available-tags',
  REFRESH_POST_INTERACTIONS: 'mfe-card-posts-refresh-post-interactions',
} as const;

export type CardPostEventName = (typeof CARD_POST_EVENTS)[keyof typeof CARD_POST_EVENTS];
